/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/UserOrganizations/UserOrganizationsService',[
    'jquery',
    'lodash',
    'global/all',
    'plugins/jquery.proxyRequest'
], function ($, _, Roc) {
    'use strict';

    /**
     * Requests api to update ship to organization budget and budget renewal date
     * @param {} updateBudgetRequest
     * @param {} requestCustomFields - dictiornary of <string, object> for passing custom fields to API
     * @returns {} 
     */
    function updateCustomerBudget(updateBudgetRequest, requestCustomFields) {
        updateBudgetRequest
            .requestCustomFields = requestCustomFields;

        return $.proxyRequest({
            type: 'POST',
            url: '/api/budget',
            data: JSON.stringify(updateBudgetRequest),
            dataType: 'json'
        });
    }

    

    var UserOrganizationsService = {
        updateCustomerBudget: updateCustomerBudget
    };

    Roc.Logger.debug('UserOrganizationsService.js Loaded:', UserOrganizationsService);

    return UserOrganizationsService;
});
